module.exports = __webpack_public_path__ + "img/temperature.fb8b4383.png";